'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat(value, label) {
  this.ia = null;
  this.i9 = null;
  this.ia = value;
  this.i9 = label;
}
export { $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat as $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat };
$p = $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat() {
}
export { $h_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat as $h_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat };
$h_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 933038611, true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat) && ((this.ia === x$0.ia) && (this.i9 === x$0.i9))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Stat";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.ia;
  }
  if ((n === 1)) {
    return this.i9;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bu)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat as $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat };
var $d_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat, "io.intela.sites.digitalinternship.data.CaseStudies$Stat", ({
  bu: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat as $d_Lio_intela_sites_digitalinternship_data_CaseStudies$Stat };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Case-Studies$-Stat.js.map
